var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 5.32684C14.6671 5.2391 14.6503 5.15213 14.6171 5.0709C14.5839 4.98968 14.535 4.9158 14.4733 4.85351L11.6466 2.02684C11.5843 1.96505 11.5104 1.91617 11.4292 1.88299C11.348 1.84982 11.261 1.833 11.1733 1.83351C11.0855 1.833 10.9985 1.84982 10.9173 1.88299C10.8361 1.91617 10.7622 1.96505 10.6999 2.02684L8.81326 3.91351L1.5266 11.2002C1.46481 11.2625 1.41593 11.3363 1.38275 11.4176C1.34957 11.4988 1.33276 11.5858 1.33326 11.6735V14.5002C1.33326 14.677 1.4035 14.8466 1.52853 14.9716C1.65355 15.0966 1.82312 15.1668 1.99993 15.1668H4.8266C4.91988 15.1719 5.01319 15.1573 5.10048 15.124C5.18776 15.0907 5.26707 15.0394 5.33326 14.9735L12.5799 7.68684L14.4733 5.83351C14.5341 5.76889 14.5837 5.69453 14.6199 5.61351C14.6264 5.56037 14.6264 5.50665 14.6199 5.45351C14.623 5.42247 14.623 5.39121 14.6199 5.36017L14.6666 5.32684ZM4.55326 13.8335H2.6666V11.9468L9.2866 5.32684L11.1733 7.21351L4.55326 13.8335ZM12.1133 6.27351L10.2266 4.38684L11.1733 3.44684L13.0533 5.32684L12.1133 6.27351Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.d8e21b07a6acb74d27a5e3b1fd1b0765.svg";
export { ForwardRef as ReactComponent };